import Lightning from '@lightningjs/core';
import {} from '@lightningjs/ui-components';
import { AppSetup } from '../../lib/app-setup';
import { AppData } from '@lightningjs/sdk';

export default class Thumb extends Lightning.Component {
    static override _template() {
        return {
            w:(w)=>w,
            h:(h)=>h,
            rect:true,
            collision:true,
            flex: { direction: 'column',alignItems:'center', justifyContent:'center',},
            colorTop: 0xFF0C0D1D,
            colorBottom: 0xFF060811,
            Icon: {
                w: 120,
                h: 120,
                flexItem: { marginTop: 60 },
                src: this.bindProp('icon'),
            } ,
            Text: {
                flexItem: { marginTop: 40 },
                text: { text: this.bindProp('title'), textColor: 0xffffffff, fontSize: 30 }
            }
        }
    }

    override _init() {
        this.parent.collision = true;
        this.parent.parent.collision = true;
    }

    _handleClick(target) {
        this._handleEnter()
        return true
    }

    // Override to handle click
    override _handleEnter() {
        this.fireAncestors('$onTileClicked', { rowIndex: this.rowIndex, itemIndex: this.itemIndex });
    }

   override _focus() {
        this.fireAncestors('$menuInfoItemFocused', this)
        this.patch({
        smooth: { 
            colorTop: 0xFFFF1A0D,
            colorBottom: 0xFF880D05,
            scale: 1.1,
        },
        Icon: {
            w: 150, h:150
        },
        zIndex: 2,
      })
      const {platform} = AppData as AppSetup
      platform?.textToSpeach(this.title)
    }

   override _unfocus() {
        this.patch({
            smooth: {
                colorTop: 0xFF0C0D1D,
                colorBottom: 0xFF060811,
                scale: 1
            },
            Icon: {
                w: 120, h:120
            },
            zIndex: 0,
        })
    }

    _handleHover(target) {
        //console.log('MenuItemThumb Hover: ',  target)
        //this._focus()
        this.fireAncestors('$handleHover', target)
    }
}
